import { z } from "zod";
import { paragraphSchema } from "../helpers/gradeValidationHelpers.js";
import { recordingIdSchema } from "./recording.js";
import {
  signalDescriptionSchema,
  signalMetadataKeySchema,
  signalNameSchema
} from "./signal.js";
const candidateMetadataFieldSchema = z.object({
  id: z.uuid().optional(),
  key: signalMetadataKeySchema,
  type: z.enum(["enum", "number"]),
  options: z.array(z.string()).optional()
});
const testSignalProposalToolInputSchema = z.object({
  candidate_name: signalNameSchema.optional().describe(
    "The proposed signal name to test. If omitted, uses the current signal name."
  ),
  candidate_description: signalDescriptionSchema.optional().describe(
    "The proposed signal description to test. If omitted, uses the current signal description."
  ),
  candidate_metadata_schema: z.array(candidateMetadataFieldSchema).nullable().optional().describe(
    "Optional metadata schema for the proposed signal. If omitted, uses the current signal metadata schema."
  )
});
const signalProposalMatchSchema = z.object({
  interaction_id: z.uuid(),
  contact_name: z.string().nullable(),
  teammate_name: z.string(),
  playbook_name: z.string(),
  matches: z.array(
    z.object({
      recording_id: recordingIdSchema,
      recorded_at: z.string().nullable(),
      explanation: z.string(),
      analysis: z.array(paragraphSchema),
      extracted_metadata: z.record(z.string(), z.union([z.string(), z.number(), z.null()])).nullable()
    })
  )
});
const testSignalProposalToolOutputSchema = z.object({
  interactions_with_matches: z.array(signalProposalMatchSchema),
  summary: z.object({
    total_interactions: z.number(),
    matched_interactions: z.number(),
    total_matches: z.number()
  })
});
export {
  candidateMetadataFieldSchema,
  testSignalProposalToolInputSchema,
  testSignalProposalToolOutputSchema
};
//# sourceMappingURL=signalConfigurationTools.js.map
